<template>
  <div class="SettingFormBox RLayoutBox">
    <el-form ref="form" :model="form" label-width="140px">
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">报废基本情况</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="24">
          <el-form-item label="车辆报废类型" prop="ScrapType">
            <el-radio-group disabled v-model="form.ScrapType">
              <el-radio :label="1">正常报废车辆</el-radio>
              <el-radio :label="2">异地报废车辆</el-radio>
              <el-radio :label="3">不完整车辆</el-radio>
              <el-radio :label="4">罚没车辆</el-radio>
              <el-radio :label="5">信息缺失车辆</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="五大总成">
            <!-- <MyCheckbox
              v-model="form.FiveMajorAssemblies"
              :checkList="FiveMajorAssembliesOptions"
              disabled
            ></MyCheckbox> -->
            <el-checkbox-group v-model="checkedCities" disabled>
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车主信息</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="6">
          <el-form-item label="车主类型">
            <div class="text">
              {{
                form.OwnerType == "1"
                  ? "个人"
                  : form.OwnerType == "2"
                  ? "单位"
                  : "-"
              }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车主姓名">
            <div class="text">{{ form.OwnerName | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系电话">
            <div class="text">{{ form.ContactNumber | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="证件类型">
            <div class="text">
              {{
                form.DocumentType == "1"
                  ? "身份证"
                  : form.DocumentType == "2"
                  ? "其他证件"
                  : "-"
              }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="证件号码">
            <div class="text">{{ form.DocumentNumber | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="邮政编码">
            <div class="text">{{ form.PostalCode | gang }}</div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="联系地址">
            <div class="text">{{ form.ContactAddress | gang }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">收款人信息</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="6">
          <el-form-item label="是否代办" prop="IsProve">
            <div class="text">
              {{
                form.IsProve == "0" ? "否" : form.IsProve == "1" ? "是" : "-"
              }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收款人姓名" prop="BankUsername">
            <div class="text">{{ form.BankUsername | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行卡号" prop="BankNo">
            <div class="text">{{ form.BankNo | gang }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="this.form.IsProve == '1' ? true : false">
        <div class="FromTitleStyle">
          <div class="FromTitleBorder"></div>
          <div class="FromTitleText">委托人信息</div>
        </div>
        <el-row class="FromElRowMargin">
          <el-col :span="6">
            <el-form-item label="姓名">
              <div class="text">{{ form.ClientUser | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话">
              <div class="text">{{ form.ClientTel | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号">
              <div class="text">{{ form.ClientCardNumber | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="委托书">
              <div>
                <el-image
                  style="width: 130px; height: 130px"
                  :src="form.ClientProveUrlUrl"
                  :preview-src-list="[form.ClientProveUrlUrl]"
                >
                </el-image>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证正面">
              <div>
                <el-image
                  style="width: 130px; height: 130px"
                  :src="form.ClientFontUrlUrl"
                  :preview-src-list="[form.ClientFontUrlUrl]"
                >
                </el-image>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证反面">
              <div>
                <el-image
                  style="width: 130px; height: 130px"
                  :src="form.ClientBackUrlUrl"
                  :preview-src-list="[form.ClientBackUrlUrl]"
                >
                </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">委托人证明</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="8">
          <el-form-item label="委托书">
            <div>
              <el-image
                style="width: 130px; height: 130px"
                :src="form.ClientProveUrlUrl"
                :preview-src-list="[form.ClientProveUrlUrl]"
              >
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证正面">
            <div>
              <el-image
                style="width: 130px; height: 130px"
                :src="form.ClientFontUrlUrl"
                :preview-src-list="[form.ClientFontUrlUrl]"
              >
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证反面">
            <div>
              <el-image
                style="width: 130px; height: 130px"
                :src="form.ClientBackUrl"
                :preview-src-list="[form.ClientBackUrl]"
              >
              </el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->

      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">经办人信息</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="12">
          <el-form-item label="经办人">
            <div class="text">{{ form.AgentName | UserNameInfo }}</div>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="身份证号">
            <div class="text">{{ form.AgentIdCardNumber | gang }}</div>
          </el-form-item>
        </el-col> -->
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车辆信息</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="6">
          <el-form-item label="车辆识别代号">
            <div class="text" :title="form.Vin">{{ form.Vin | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="号牌号码">
            <div class="text" :title="form.LicensePlate">
              {{ form.LicensePlate | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- | CodeName(this.$g.VehicleType) -->
          <el-form-item label="车辆类型">
            <div
              class="text"
              :title="form.VehicleType | CodeName(this.$g.VehicleType)"
            >
              {{ form.VehicleType | CodeName(this.$g.VehicleType) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="动力类型">
            <div class="text">
              {{ form.PowerType | CodeName(this.$g.VehiclePowerType) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆品牌">
            <div class="text">{{ form.Brand | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="使用性质">
            <div class="text">
              {{ form.UsageType | CodeName(this.$g.UsageType) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发动机型号">
            <div class="text">{{ form.EngineModel | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆型号">
            <div class="text">{{ form.Model | gang }}</div>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="变速器型号">
            <div class="text">{{ form.TransmissionModel | gang }}</div>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="发动机号码">
            <div class="text">{{ form.EngineNumber | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="载客人数(人)">
            <div class="text">{{ form.SeatingCapacity | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收车日期">
            <div class="text">
              {{ form.RegistrationDate | datetime("YYYY-MM-DD") }}
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="整备质量(kg)">
            <div class="text">{{ form.CurbWeight | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发动机排量(L)">
            <div class="text">{{ form.Displacement | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="额定功率(kW)">
            <div class="text">{{ form.Power | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="里程表读数(km)">
            <div class="text">{{ form.TotalMileage | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否有动力电池">
            <div class="text">
              {{ form.HasBattery | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车身颜色">
            <div class="text">
              {{ form.BodyColor | CodeName(this.$g.CarColor) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="号牌种类">
            <div class="text">
              {{ form.PlateType | CodeName(this.$g.LicensePlateType) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="登记证书编号">
            <div class="text" :title="form.RegistrationCertNo">
              {{ form.RegistrationCertNo | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆状态">
            <div class="text">{{ form.VehicleStatus | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="行驶证编号">
            <div class="text" :title="form.DrivingLicenseNo">
              {{ form.DrivingLicenseNo | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="业务流水号">
            <div class="text" :title="form.TransactionId">
              {{ form.TransactionId | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="回收证明编号">
            <div class="text" :title="form.RecycleCertNo">
              {{ form.RecycleCertNo | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入库编号">
            <div class="text">{{ form.StorageId | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="场地编号">
            <div class="text" :title="form.LocationId">
              {{ form.LocationId | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="资料编号">
            <div class="text" :title="form.DocumentId">
              {{ form.DocumentId | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="来源">
            <div class="text">{{ form.Source | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="注销日期">
            <div class="text">
              {{ form.CancellationDate | datetime("YYYY-MM-DD") }}
            </div>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="6">
          <el-form-item label="实际质量(kg)">
            <div class="text">{{ form.ActualWeight | gang }}</div>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="6">
          <el-form-item label="单价(元)">
            <div class="text">{{ form.UnitPrice | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="补充支付(元)">
            <div class="text">{{ form.AdditionalPayment | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算金额(元)">
            <div class="text">{{ form.SettlementAmount | gang }}</div>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="车牌颜色">
            <div class="text">
              {{ form.PlateColor | CodeName(this.$g.LicensePlateColor) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否有行驶证">
            <div class="text">
              {{ form.HasDriverLicense | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="是否有登记证书"
            prop="HasRegistrationCertificate"
          >
            <div class="text">
              {{ form.HasRegistrationCertificate | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否有三元催化">
            <div class="text">
              {{ form.HasCatalyticConverter | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否有号牌">
            <div class="text">
              {{ form.HasLicensePlate | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否有电瓶">
            <div class="text">
              {{ form.HasVehicleBattery | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="是否有购置税本">
            <div class="text">
              {{ form.HasPurchaseTaxReceipt | enumer("yes_no_state") }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">照片信息</div>
      </div>
      <el-row class="FromElRowMargin">
        <el-col :span="3">
          <el-form-item label="整车照">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.VehiclePhotoUrl"
                :preview-src-list="[form.VehiclePhotoUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="拆解照">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.DismantlePhotoUrl"
                :preview-src-list="[form.DismantlePhotoUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="大架号照">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.VinPhotoUrl"
                :preview-src-list="[form.VinPhotoUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="切割大架号照片">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.CutVinPhotoUrl"
                :preview-src-list="[form.CutVinPhotoUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="注销证明">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.CancellationProofUrl"
                :preview-src-list="[form.CancellationProofUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="登记证明">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.RegisterProofUrl"
                :preview-src-list="[form.RegisterProofUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="电池缺失证明">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.BatteryMissingProofUrl"
                :preview-src-list="[form.BatteryMissingProofUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-footer>
        <div class="FromElRowMargin">
          <el-button type="canale" size="medium" @click="reset">关闭</el-button>
        </div>
      </el-footer>
    </el-form>
  </div>
</template>

<script>
import UploadPhoto from "@/components/UploadPhoto.vue";
// const DocumentTypeOptions = ["车架", "发动机", "变速器", "前后桥", "方向机"];
const cityOptions = ["车架", "发动机", "变速器", "前后桥", "方向机"];
export default {
  components: {
    UploadPhoto,
  },
  data() {
    return {
      //   FiveMajorAssemblies: ["车架", "发动机"],
      // FiveMajorAssembliesOptions: DocumentTypeOptions.map((m) => {
      //   return {
      //     value: m,
      //     label: m,
      //   };
      // }),

      checkedCities: [],
      cities: cityOptions,

      form: {},
      routeTab: "查看登记信息",
    };
  },

  computed: {
    isEdit() {
      return this.$route.params.IsEdit ? true : false;
    },
  },
  mounted() {
    this.$get("VehicleRegistration/GetItem", {
      KeyId: this.$route.params.KeyId,
    }).then((r) => {
      if (r.Result.FiveMajorAssemblies) {
        this.checkedCities = JSON.parse(r.Result.FiveMajorAssemblies);
      }

      this.form = { ...r.Result };
    });
  },
  activated() {},
  watch: {},
  methods: {
    reset() {
      this.$tabs.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.RLayoutBox {
  height: calc(100vh - 114px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.FromSearchMargin {
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
</style>

 